import { Box } from '@mui/material';
import { TranscriptionSyncAction } from '../actions/TranscriptionSyncAction';
import { TranscriptionWordEfficiencyAction } from '../actions/TranscriptionWordEfficiencyAction';
import { TranscriptionSearch } from '../search/TranscriptionSearch';

type TranscriptionViewV2ToolbarProps = {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  followPlayback: boolean;
  /** Called only from the toolbar when the user enables sync from the off state. */
  onSyncIconClick: () => void;
  showWordEfficiency: boolean;
  /** Toggles per-word confidence (eficiencia) background colors. */
  onWordEfficiencyClick: () => void;
};

/** Toolbar row: transcript search on the left; follow-playback sync and word-efficiency toggles on the right. */
export function TranscriptionToolbar({
  searchQuery,
  onSearchQueryChange,
  followPlayback,
  onSyncIconClick,
  showWordEfficiency,
  onWordEfficiencyClick,
}: TranscriptionViewV2ToolbarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        gap: 1,
        mb: 1,
      }}
    >
      <TranscriptionSearch query={searchQuery} onQueryChange={onSearchQueryChange} />
      <Box sx={{ display: 'flex', flexShrink: 0, gap: 0.5 }}>
        <TranscriptionSyncAction
          followPlayback={followPlayback}
          onSyncIconClick={onSyncIconClick}
        />
        <TranscriptionWordEfficiencyAction
          showWordEfficiency={showWordEfficiency}
          onWordEfficiencyClick={onWordEfficiencyClick}
        />
      </Box>
    </Box>
  );
}
